export default __webpack_public_path__ + "static/media/texture.f3721ed7.jpg";